export default {
  methods: {
    updateChoice(option, type) {
      this.$store.dispatch('updateChoice', { option: option, type: type })
    },
    updateURLChoice(url, type) {
      this.$store.dispatch('updateURLChoice', { url: url, type: type })
    },
  }
}